<template>
    <div class="status status_close" v-if="params.type === 'close'">{{ t('courseComp.statuses.close') }}</div>
    <div class="status status_open" v-else-if="params.type === 'open'">{{ t('courseComp.statuses.open') }}</div>
    <div class="status status_recruiting" v-else-if="params.type === 'recruiting'">
        {{ t('courseComp.statuses.recruit') }}
    </div>
    <div class="status status_pay" v-else-if="params.type === 'pay'">{{ t('courseComp.statuses.paid') }}</div>
</template>

<script>
import {useI18n} from "vue-i18n";

export default {
    name: 'Status',
    props: {
        params: {
            type: Object
        }
    },
    setup() {
        const {t} = useI18n()
        return {
            t
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/status.scss';
</style>
